import React from 'react'

export default function Layouts301() {
  return (
    <section><a className="anchor" id="redirect"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/redirect.html"><img src="images/redirect.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h2>301 Error</h2>
            <p>Live example of the 301 error page.</p>
            <p><a className="btn btn--large" href="samples/redirect.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/redirect.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Layouts301.js